module.exports = __webpack_public_path__ + "static/media/pro_mis_logo.fac5d35f.svg";